/* eslint-disable react/prefer-stateless-function */
/* eslint-disable max-classes-per-file */
import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { SnackbarProvider, PLACEMENT } from 'baseui/snackbar';
import {
	DrawerProvider,
	AppProvider,
	UserProvider,
	AjaxProvider,
	EffectProvider,
	GLOBAL_THEME,
	DASHBOARD,
	ModalProvider,
	MerchantProvider,
	MerchantContext
} from 'commons-ui';
import { BaseProvider, LightTheme, useStyletron } from 'baseui';
import { Provider as StyletronProvider } from 'styletron-react';
import { Client as Styletron } from 'styletron-engine-atomic';
import config from 'config';
import Routes from '../routes/Routes';

const engine = new Styletron();

const PrimaryLayout: React.FC<{}> = () => {
	const [css] = useStyletron();
	return (
		<BaseProvider theme={LightTheme}>
			<MerchantProvider>
				<SnackbarProvider placement={PLACEMENT.bottom}>
					<EffectProvider>
						<AjaxProvider baseURL={config.API_URL} adminBaseUrl={config.ADMIN_API_URL}>
							<UserProvider>
								<AppProvider dashboard={DASHBOARD.MARKETING} MerchantContext={MerchantContext}>
									<DrawerProvider>
										<ModalProvider>
											<div
												className={css({
													position: 'fixed',
													overflow: 'auto',
													top: 0,
													bottom: 0,
													left: 0,
													right: 0,
													backgroundColor: GLOBAL_THEME.Colors.lightGrey
												})}>
												<Routes />
											</div>
										</ModalProvider>
									</DrawerProvider>
								</AppProvider>
							</UserProvider>
						</AjaxProvider>
					</EffectProvider>
				</SnackbarProvider>
			</MerchantProvider>
		</BaseProvider>
	);
};

class App extends Component {
	render() {
		return (
			<StyletronProvider value={engine}>
				<BrowserRouter>
					<PrimaryLayout />
				</BrowserRouter>
			</StyletronProvider>
		);
	}
}
export default App;
